<template>
	<div class="song-settings" :class="{ 'song-settings--disabled': disabled }">
		<div class="song-settings__section">
			<svg v-if="!isMts" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
				<path
					d="M16.9531 2.71881C16.7857 2.6038 16.5926 2.53149 16.3908 2.50821C16.189 2.48492 15.9846 2.51136 15.7953 2.58522C14.6992 3.01178 12.4859 3.72741 10 3.72741C7.51406 3.72741 5.3 3.01178 4.20234 2.58522C4.01296 2.5117 3.8085 2.48545 3.60669 2.50875C3.40487 2.53204 3.21177 2.60417 3.04411 2.71889C2.87645 2.83362 2.73928 2.98748 2.64447 3.16715C2.54966 3.34683 2.50007 3.54691 2.5 3.75006V8.1071C2.5 10.9071 3.25391 13.5485 4.62344 15.543C6.04219 17.6102 7.95156 18.7462 10 18.7462C12.0484 18.7462 13.9578 17.6079 15.3766 15.543C16.7461 13.5501 17.5 10.9087 17.5 8.10866V3.75006C17.4996 3.54665 17.4496 3.34639 17.3543 3.16668C17.259 2.98697 17.1213 2.83324 16.9531 2.71881ZM6.09375 10.4165C6.03902 10.478 5.97269 10.5282 5.89857 10.5641C5.82444 10.6001 5.74397 10.621 5.66174 10.6258C5.49566 10.6356 5.33252 10.579 5.2082 10.4684C5.08388 10.3579 5.00857 10.2025 4.99882 10.0364C4.98908 9.87034 5.04571 9.7072 5.15625 9.58288C5.60547 9.08444 6.42031 8.75006 7.1875 8.75006C7.95469 8.75006 8.76953 9.08444 9.21875 9.58288C9.27348 9.64443 9.31556 9.71617 9.34257 9.79399C9.36958 9.8718 9.381 9.95418 9.37618 10.0364C9.37135 10.1186 9.35038 10.1991 9.31445 10.2732C9.27853 10.3474 9.22835 10.4137 9.1668 10.4684C9.10524 10.5232 9.0335 10.5652 8.95569 10.5922C8.87787 10.6193 8.79549 10.6307 8.71326 10.6258C8.63103 10.621 8.55056 10.6001 8.47643 10.5641C8.40231 10.5282 8.33598 10.478 8.28125 10.4165C8.07188 10.1821 7.58984 10.0001 7.1875 10.0001C6.78516 10.0001 6.3 10.1829 6.09375 10.4165ZM13.1633 14.1555C12.7753 14.6158 12.2915 14.9858 11.7457 15.2396C11.1998 15.4935 10.6051 15.625 10.0031 15.625C9.40115 15.625 8.80643 15.4935 8.26058 15.2396C7.71473 14.9858 7.23091 14.6158 6.84297 14.1555C6.78377 14.0942 6.73773 14.0215 6.70768 13.9417C6.67764 13.862 6.66421 13.7769 6.66824 13.6918C6.67227 13.6067 6.69366 13.5233 6.7311 13.4468C6.76854 13.3702 6.82124 13.3021 6.88596 13.2467C6.95068 13.1912 7.02605 13.1496 7.10744 13.1244C7.18884 13.0992 7.27453 13.0908 7.35926 13.0999C7.44399 13.109 7.52597 13.1354 7.60015 13.1773C7.67433 13.2192 7.73915 13.2759 7.79063 13.3438C8.06113 13.6668 8.39914 13.9265 8.78087 14.1047C9.16259 14.2829 9.57873 14.3752 10 14.3752C10.4213 14.3752 10.8374 14.2829 11.2191 14.1047C11.6009 13.9265 11.9389 13.6668 12.2094 13.3438C12.317 13.2177 12.4703 13.1396 12.6356 13.1265C12.8009 13.1135 12.9645 13.1666 13.0906 13.2743C13.2167 13.3819 13.2949 13.5352 13.3079 13.7005C13.3209 13.8658 13.2678 14.0295 13.1602 14.1555H13.1633ZM14.7922 10.4688C14.731 10.5236 14.6596 10.5657 14.5821 10.5929C14.5047 10.6201 14.4226 10.6317 14.3406 10.6271C14.2586 10.6226 14.1783 10.6019 14.1043 10.5663C14.0303 10.5307 13.9641 10.4808 13.9094 10.4196C13.7 10.1852 13.218 10.0032 12.8156 10.0032C12.4133 10.0032 11.9281 10.186 11.7219 10.4196C11.6669 10.4814 11.6004 10.5317 11.526 10.5677C11.4516 10.6038 11.3708 10.6248 11.2883 10.6296C11.2058 10.6344 11.1231 10.623 11.045 10.5958C10.9669 10.5687 10.895 10.5265 10.8332 10.4715C10.7714 10.4166 10.7211 10.35 10.6851 10.2756C10.649 10.2013 10.628 10.1205 10.6232 10.038C10.6184 9.95545 10.6298 9.87279 10.657 9.7947C10.6841 9.71662 10.7263 9.64464 10.7812 9.58288C11.2273 9.08444 12.0422 8.75006 12.8125 8.75006C13.5828 8.75006 14.3945 9.08444 14.8438 9.58288C14.8988 9.64428 14.9412 9.71599 14.9685 9.79386C14.9957 9.87173 15.0073 9.95423 15.0025 10.0366C14.9977 10.1189 14.9767 10.1995 14.9406 10.2737C14.9045 10.3479 14.854 10.4142 14.7922 10.4688Z"
					fill="currentColor"
				/>
			</svg>
			<img v-else src="@/resources/icons/mts/ph_mask-happy-fill_mts.svg" alt="" class="song-settings__icon" />
			<div class="song-settings__chips">
				<button
					v-for="mood in MOODS"
					:key="mood.value"
					:class="['song-settings__chip', { 'song-settings__chip--active': selectedMoods.includes(mood.value) }]"
					:disabled="disabled"
					@click="toggleMood(mood.value)"
				>
					{{ mood.label }}
				</button>
			</div>
		</div>
		<div class="song-settings__section">
			<svg v-if="!isMts" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
				<path
					d="M17.1161 1.54292C17.2358 1.63309 17.3325 1.74774 17.399 1.8783C17.4655 2.00886 17.5 2.15196 17.5 2.29694V13.5322C17.5 13.5707 17.4976 13.6096 17.4929 13.6487C17.4976 13.7161 17.5 13.7842 17.5 13.8529C17.4997 14.4661 17.2936 15.0633 16.9115 15.558C16.5295 16.0528 15.9913 16.4195 15.3749 16.605C14.7585 16.7905 14.0958 16.7852 13.4828 16.5899C12.8697 16.3947 12.3381 16.0195 11.9649 15.5187C11.5917 15.0179 11.3961 14.4176 11.4067 13.8044C11.4172 13.1913 11.6331 12.5973 12.0233 12.1083C12.4135 11.6193 12.9577 11.2607 13.5771 11.0844C14.1965 10.9081 14.859 10.9232 15.4688 11.1276V7.3623L7.34375 9.16021V15.7818C7.34298 16.3949 7.13651 16.9919 6.75421 17.4864C6.37192 17.9808 5.83362 18.3472 5.2172 18.5324C4.60078 18.7176 3.9382 18.712 3.32533 18.5165C2.71246 18.321 2.18108 17.9457 1.80807 17.4449C1.43505 16.9441 1.23975 16.3437 1.25041 15.7307C1.26108 15.1176 1.47716 14.5237 1.86739 14.0348C2.25763 13.546 2.80177 13.1875 3.42111 13.0113C4.04045 12.835 4.70286 12.8502 5.3125 13.0546V4.54361C5.31247 4.32619 5.39005 4.11517 5.53259 3.94486C5.67513 3.77456 5.87426 3.65501 6.09758 3.60565L16.2538 1.35898C16.4014 1.32646 16.5548 1.32566 16.7028 1.35665C16.8508 1.38765 16.9896 1.44964 17.109 1.5381L17.1161 1.54292Z"
					fill="currentColor"
				/>
			</svg>
			<img v-else src="@/resources/icons/mts/music_icon_mts.svg" alt="" class="song-settings__icon" />
			<div class="song-settings__chips">
				<button
					v-for="genre in GENRES"
					:key="genre.value"
					:class="['song-settings__chip', { 'song-settings__chip--active': selectedGenres.includes(genre.value) }]"
					:disabled="disabled"
					@click="toggleGenre(genre.value)"
				>
					{{ genre.label }}
				</button>
			</div>
		</div>
		<div class="song-settings__section">
			<svg v-if="!isMts" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
				<path
					d="M2.76461 17.2417C3.09151 17.5686 3.51899 17.7362 3.94647 17.7362C4.33204 17.7362 4.70923 17.6021 5.02774 17.3423L11.8171 11.6258L7.3747 7.1833L1.65819 13.9727C1.09659 14.6433 1.1385 15.6156 1.75877 16.2358L2.76461 17.2417ZM12.7056 1.26562C11.3645 1.26562 10.1072 1.78531 9.14329 2.74085C8.45597 3.43656 7.99496 4.2999 7.7938 5.2303L13.7785 11.215C14.7089 11.0139 15.5723 10.5529 16.2764 9.85715C17.2235 8.90161 17.7432 7.63593 17.7432 6.30319C17.7432 4.97046 17.2235 3.70478 16.268 2.74085C15.3244 1.8005 14.0462 1.27296 12.714 1.27401L12.7056 1.26562Z"
					fill="currentColor"
				/>
			</svg>
			<img
				v-else
				src="@/resources/icons/mts/boxicons_microphone-alt-2-filled_mts.svg"
				alt=""
				class="song-settings__icon"
			/>
			<div class="song-settings__chips">
				<button
					v-for="vocal in VOCALS"
					:key="vocal.value"
					:class="['song-settings__chip', { 'song-settings__chip--active': selectedVocal === vocal.value }]"
					:disabled="disabled"
					@click="selectedVocal = vocal.value"
				>
					{{ vocal.label }}
				</button>
			</div>
		</div>
		<div class="song-settings__section">
			<svg v-if="!isMts" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
				<path
					d="M1.97077 15.5322C1.89472 15.5858 1.80543 15.6175 1.71262 15.6238C1.61981 15.6301 1.52704 15.6109 1.44443 15.5681C1.36182 15.5253 1.29254 15.4607 1.24413 15.3813C1.19573 15.3018 1.17006 15.2106 1.16992 15.1176V4.88343C1.16987 4.79032 1.1954 4.69898 1.24373 4.61939C1.29207 4.53981 1.36133 4.47503 1.44398 4.43213C1.52662 4.38924 1.61946 4.36988 1.71236 4.37616C1.80526 4.38244 1.89465 4.41413 1.97077 4.46776L9.22004 9.58484C9.28652 9.63176 9.34076 9.69396 9.3782 9.76621C9.41564 9.83845 9.43518 9.91863 9.43518 10C9.43518 10.0814 9.41564 10.1615 9.3782 10.2338C9.34076 10.306 9.28652 10.3682 9.22004 10.4152L1.97077 15.5322ZM10.3166 4.88343C10.3166 4.79032 10.3421 4.69898 10.3904 4.61939C10.4388 4.53981 10.508 4.47503 10.5907 4.43213C10.6733 4.38924 10.7662 4.36988 10.8591 4.37616C10.952 4.38244 11.0414 4.41413 11.1175 4.46776L18.3668 9.58484C18.4332 9.63176 18.4875 9.69396 18.5249 9.76621C18.5623 9.83845 18.5819 9.91863 18.5819 10C18.5819 10.0814 18.5623 10.1615 18.5249 10.2338C18.4875 10.306 18.4332 10.3682 18.3668 10.4152L11.1175 15.5322C11.0414 15.5858 10.9521 15.6175 10.8593 15.6238C10.7665 15.6301 10.6738 15.6109 10.5911 15.5681C10.5085 15.5253 10.4392 15.4607 10.3908 15.3813C10.3424 15.3018 10.3168 15.2106 10.3166 15.1176V4.88343Z"
					fill="currentColor"
				/>
			</svg>
			<img v-else src="@/resources/icons/mts/ri_speed-mini-fill_mts.svg" alt="" class="song-settings__icon" />
			<div class="song-settings__chips">
				<button
					v-for="tempo in TEMPOS"
					:key="tempo.value"
					:class="['song-settings__chip', { 'song-settings__chip--active': selectedTempo === tempo.value }]"
					:disabled="disabled"
					@click="selectedTempo = tempo.value"
				>
					{{ tempo.label }}
				</button>
			</div>
		</div>
	</div>
</template>

<script setup lang="ts">
import { ref, watch } from 'vue'
import AppConfig from '@/config'

const isMts = AppConfig.isMts

export interface SongSettingsValue {
	moods: string[]
	genres: string[]
	vocal: string
	tempo: string
}

const props = defineProps<{
	disabled?: boolean
	initialMoods?: string[]
	initialGenres?: string[]
	initialVocal?: string
	initialTempo?: string
}>()

const emit = defineEmits<{ change: [value: SongSettingsValue] }>()

const MOODS = [
	{ value: 'joy', label: 'Радость' },
	{ value: 'sadness', label: 'Грусть' },
	{ value: 'inspiration', label: 'Воодушевление' },
	{ value: 'melancholy', label: 'Меланхолия' },
	{ value: 'tenderness', label: 'Нежность' },
	{ value: 'romance', label: 'Романтика' },
	{ value: 'calm', label: 'Спокойствие' },
	{ value: 'anxiety', label: 'Тревога' },
	{ value: 'happiness', label: 'Счастье' },
	{ value: 'anger', label: 'Злость' }
]
const GENRES = [
	{ value: 'electronic', label: 'Электронная' },
	{ value: 'rock', label: 'Рок' },
	{ value: 'soundtrack', label: 'Саундтрек' },
	{ value: 'hip-hop', label: 'Хип-хоп' },
	{ value: 'pop', label: 'Поп' },
	{ value: 'ballad', label: 'Баллада' },
	{ value: 'folk', label: 'Фолк' },
	{ value: 'lo-fi', label: 'Lo-Fi' },
	{ value: 'dance', label: 'Танцевальная' },
	{ value: 'metal', label: 'Металл' }
]
const VOCALS = [
	{ value: 'male vocal', label: 'Мужской' },
	{ value: 'female vocal', label: 'Женский' }
]
const TEMPOS = [
	{ value: 'slow', label: 'Медленно' },
	{ value: 'moderate', label: 'Умеренно' },
	{ value: 'fast', label: 'Быстро' }
]

const selectedMoods = ref<string[]>(props.initialMoods ?? [MOODS[0].value])
const selectedGenres = ref<string[]>(props.initialGenres ?? [GENRES[0].value])
const selectedVocal = ref(props.initialVocal ?? VOCALS[0].value)
const selectedTempo = ref(props.initialTempo ?? TEMPOS[0].value)

function toggleMood(mood: string) {
	const idx = selectedMoods.value.indexOf(mood)
	if (idx === -1) {
		selectedMoods.value.push(mood)
	} else if (selectedMoods.value.length > 1) {
		selectedMoods.value.splice(idx, 1)
	}
}

function toggleGenre(genre: string) {
	const idx = selectedGenres.value.indexOf(genre)
	if (idx === -1) {
		selectedGenres.value.push(genre)
	} else if (selectedGenres.value.length > 1) {
		selectedGenres.value.splice(idx, 1)
	}
}

watch(
	[selectedMoods, selectedGenres, selectedVocal, selectedTempo],
	() => {
		emit('change', {
			moods: selectedMoods.value,
			genres: selectedGenres.value,
			vocal: selectedVocal.value,
			tempo: selectedTempo.value
		})
	},
	{ deep: true, immediate: true }
)
</script>

<style lang="scss">
.song-settings {
	padding: 16px;
	max-width: 452px;
	margin: 0 auto;
	border-radius: var(--radius-lg);
	background-color: var(--background-primary);
	box-shadow: var(--shadow-card);

	&__section {
		margin-bottom: 10px;
		display: flex;
		gap: 8px;
		align-items: center;
	}

	svg,
	&__icon {
		width: 20px;
		height: 20px;
		flex-shrink: 0;

		path {
			fill: var(--text-brand);
		}
	}

	&__chips {
		display: flex;
		gap: 4px;
		flex-wrap: wrap;
	}

	&__chip {
		padding: 4px 8px;
		outline: none;
		border: none;
		border-radius: var(--radius-tag);
		background: var(--background-chip);
		color: var(--text-chip);
		font: var(--font-micro-strong);
		cursor: pointer;

		&--active {
			background: var(--background-chip-active);
			color: var(--text-inverse);
		}
	}
}
</style>
